"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.wizard.title': 'Kreator Onboardingu',
    'onboarding.wizard.reset': 'Resetuj',
    'onboarding.wizard.loading': 'Ładowanie...',
    'onboarding.wizard.step.progress': 'Krok {current} z {total}',
    'onboarding.wizard.tab.profession': 'Wybierz Zawód',
    'onboarding.wizard.tab.steps': 'Wykonaj Kroki',
    'onboarding.wizard.tab.review': 'Przegląd',
    'onboarding.wizard.tab.completed': 'Zakończono',
    'onboarding.wizard.profession.title': 'Wybierz Swój Zawód',
    'onboarding.wizard.profession.subtitle': 'Wybierz zawód który najlepiej odpowiada Twojej roli, aby otrzymać spersonalizowane kroki onboardingu.',
    'onboarding.wizard.profession.select': 'Wybierz',
    'onboarding.wizard.profession.selected': 'Wybrano',
    'onboarding.wizard.profession.continue': 'Kontynuuj z {profession}',
    'onboarding.wizard.profession.loading': 'Ładowanie zawodów...',
    'onboarding.wizard.profession.empty': 'Brak dostępnych zawodów. Skontaktuj się z administratorem.',
    'onboarding.wizard.navigation.previous': 'Poprzedni',
    'onboarding.wizard.navigation.next': 'Następny Krok',
    'onboarding.wizard.navigation.complete': 'Zakończ Onboarding',
    'onboarding.wizard.navigation.backToSteps': 'Powrót do Kroków',
    'onboarding.wizard.navigation.confirmComplete': 'Potwierdź i Zakończ',
    'onboarding.wizard.questions.placeholder': 'Wprowadź swoją odpowiedź...',
    'onboarding.wizard.questions.required': '*',
    'onboarding.wizard.questions.selectOption': 'Proszę wybrać opcję...',
    'onboarding.wizard.questions.empty': 'Brak dostępnych pytań dla tego kroku.',
    'onboarding.wizard.review.title': 'Przejrzyj Swój Onboarding',
    'onboarding.wizard.review.subtitle': 'Przejrzyj swoje odpowiedzi przed zakończeniem procesu onboardingu.',
    'onboarding.wizard.review.profession': 'Wybrany Zawód',
    'onboarding.wizard.review.steps': 'Wykonane Kroki',
    'onboarding.wizard.review.notSelected': 'Nie wybrano',
    'onboarding.wizard.completed.title': 'Onboarding Zakończony!',
    'onboarding.wizard.completed.message': 'Gratulacje! Pomyślnie zakończyłeś proces onboardingu dla {profession}.',
    'onboarding.wizard.completed.fallback': 'twojego zawodu',
    'onboarding.wizard.completed.startNew': 'Rozpocznij Nowy Onboarding',
};
